import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateCartItemsByUserIdAsync, removeCartItemsByUserIdAsync } from "./Cart_Slice";
import toast from "react-hot-toast"
import ConfirmDialog from "../../components/Common/ConfirmDialog";
import { useState } from "react";
import { addItemInUserWishlistAsync, removeItemFromUserWishlistAsync, userWishlist } from "../User/userSlice.js";
import { loggedInUser } from "../Auth/Auth_Slice.js";

const formatNumber = (number) => {
    if (number) {
        let x = number;
        x = x.toString();
        let lastThree = x.substring(x.length - 3);
        let otherNumbers = x.substring(0, x.length - 3);
        if (otherNumbers !== '')
            lastThree = ',' + lastThree;
        let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return res;
    }
}

function CartItems({ padding, border = false }) {
    const products = useSelector(state => state.cart.items);
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [removeProductCartId, setRemoveProductCartId] = useState(null);

    const user = useSelector(loggedInUser);
    const wishlist = useSelector(userWishlist);


    const getWishlistItem = (currentProductId) => {
        if (!wishlist || wishlist.length === 0) return undefined;
        return wishlist.find((item) => item.productId === currentProductId);
    };




    const handleOnConfirmAction = async () => {
        const response = await dispatch(removeCartItemsByUserIdAsync(removeProductCartId.id));
        if (response?.payload.status === "success") {
            setIsModalOpen(!isModalOpen);
            toast.success(`Successfully removed '${removeProductCartId.name}' from your cart.`, {
                id: "success",
                duration: 6000,
            })
            setRemoveProductCartId(null)
        } else {
            toast.error(response?.payload.message, { id: "error" });
        }
    };

    const handleCancelRemove = () => {
        setIsModalOpen(() => !isModalOpen);
    };

    const regex = /\(([^)]+)\)/;

    const increaseQuantity = async (cartItem) => {
        //here this is cartId not a productId
        if (cartItem.quantity < 10) {
            const response = await dispatch(updateCartItemsByUserIdAsync({ id: cartItem.id, quantity: cartItem.quantity + 1 }))
            if (response?.payload.status === "success") {
                toast.success(`You've changed '${response.payload.message.name}' QUANTITY to ${response.payload.message.quantity}`, {
                    id: "success",
                    duration: 4000,
                })
            } else {
                toast.error(response?.payload.message, { id: "error" });
            }
        } else {
            toast.error("We're sorry! Only 10 unit(s) allowed in each order", {
                id: "warning",
                icon: <svg xmlns="http://www.w3.org/2000/svg" fill="#f59e0b" className="w-4 mr-1" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" /></svg>,
                style: { width: 'auto' }
            })
        }
    }
    const decreaseQuantity = async (cartItem) => {
        //here this is cartId not a productId
        if (cartItem.quantity > 1) {
            const response = await dispatch(updateCartItemsByUserIdAsync({ id: cartItem.id, quantity: cartItem.quantity - 1 }))
            if (response.payload.status === "success") {
                toast.success(`You've changed '${response.payload.message.name}' QUANTITY to ${response.payload.message.quantity}`, {
                    id: "success",
                    duration: 4000,
                })
            } else {
                toast.error(response?.payload.message, { id: "error" });
            }
        }
    }

    const handleRemoveProduct = (product) => {
        setIsModalOpen(() => !isModalOpen);
        setRemoveProductCartId({ id: product.id, name: product.name })
    }

    const handleSaveToWishlist = (productId) => {
        if (user && user?.isAuthenticated && products) {
            dispatch(addItemInUserWishlistAsync(productId)).then((response) => {
                if (response.payload.status === 'success') {
                    toast.success("Added to your Wishlist.", { id: "success" })
                } else {
                    toast.error(response.payload.message, { id: "error" })
                }
            });
        }
    }

    const handleRemoveFromWishlist = (productId) => {
        if (user && user?.isAuthenticated && products) {
            dispatch(removeItemFromUserWishlistAsync(productId)).then((response) => {
                if (response.payload.status === 'success') {
                    toast.success("Product removed from Wishlist.", { id: "success" })
                } else {
                    toast.error(response.payload.message, { id: "error" })
                }
            });
        }
    }

    return (
        <ul className={`${border ? "border-gray-200 border-b-[1px] border-t-[1px]" : ""}`}>
            {products && products.map((product) => (
                <li key={product.id} className={`flex flex-wrap ${padding} border-gray-200 border-b-[1px]`}>
                    <div className='flex basis-full'>
                        <div key={product.id} className='shrink-0'>
                            <img src={product.images[0]} alt={product.imageAlt} className='h-[7.5rem] w-[7.5rem] rounded-md	object-contain sm:h-32 sm:w-32' />
                        </div>
                        <div className='ml-4 flex flex-1 flex-col justify-between sm:ml-6'>
                            <div className="sm:grid relative pr-9 sm:grid-cols-1 sm:gap-6 sm:pr-0 justify-between">
                                <div className='text-realated'>
                                    <div className='flex justify-between'>
                                        <h3 className='text-base leading-7'>
                                            <Link to={`/${product.href}/${product.productId}`} className='font-normal text-opacity-100 text-gray-800 hover:text-indigo-600 duration-75'>{product.name.replace(/\(.*?\)/g, '')}</Link>
                                        </h3>
                                    </div>
                                    <div className='mt-1 flex text-sm leading-5'>

                                        {product && product?.color && <p className='border-gray-300 text-gray-500 borderLeftCustom'>{product.color}</p>}
                                        {product && product?.size && <p className='border-gray-300 text-gray-500 borderLeftCustom'>{product.size}</p>}

                                        {(regex.exec(product.name)[1]).split(",").map((ProductInfo, index) => (
                                            <p key={ProductInfo + index} className='border-gray-300 text-gray-500 borderLeftCustom'> {ProductInfo}</p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className='stock-section'>
                                <p className='mt-4 flex text-sm text-gray-700	'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-5 w-5 shrink-0	text-green-500"><path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd"></path></svg>
                                    <span className='text-opacity-100 text-gray-500	px-1'>{product.stock ? "In stock" : "Out Of Stock"}</span>
                                </p>
                            </div>
                            <div className="flex items-baseline">
                                <p className='mt-1 text-sm	leading-5	font-medium text-gray-500 pr-3 line-through'>₹{formatNumber(product.originalPrice)}</p>
                                <p className='mt-1 text-lg	leading-5	font-medium	text-gray-900'>₹{formatNumber(product.price)}</p>
                                <p className='mt-1 text-xs font-bold	text-green-500 mx-2'>{Math.round((product.price / product.originalPrice) * 100)}% Off</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex basis-full mt-3 items-center'>
                        <div className='shrink-0 w-[7.5rem] sm:w-32 flex justify-around'>
                            <button disabled={product?.quantity === 1 ? true : false} onClick={() => decreaseQuantity(product)} type='button' className={`w-8 ${product?.quantity === 1 ? "opacity-50" : ""} text-gray-700 shadow-sm text-center rounded-full border-[1px] border-gray-300 focus:border-gray-300 focus:outline-none focus:ring-0`}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-8 mx-auto"><path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" /></svg></button>
                            <input type="button" className='w-10  sm:w-12  h-8 text-gray-700 shadow-sm text-center text-base sm:text-sm	font-medium rounded-md border-[1px] border-gray-300 focus:border-gray-400 focus:outline-none focus:ring-0' readOnly={true} value={product.quantity} />
                            <button onClick={() => increaseQuantity(product)} type='button' className={`w-8 text-gray-700 shadow-sm text-center rounded-full border-[1px] border-gray-300 focus:border-gray-300 focus:outline-none focus:ring-0 `}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-8 mx-auto"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" /></svg></button>
                        </div>
                        <div className="basis-full sm:ml-6 ml-4 flex justify-between mt-1">
                            <button
                                type="button"
                                onClick={() => {
                                    const existingWishlistItem = getWishlistItem(product.productId);
                                    if (existingWishlistItem) {
                                        handleRemoveFromWishlist(existingWishlistItem.productId);
                                    } else {
                                        handleSaveToWishlist(product.productId);
                                    }
                                }}
                                className='text-sm leading-7 font-medium text-gray-900 hover:text-indigo-600 transition-colors uppercase text-left'
                            >
                                {getWishlistItem(product.productId) ? 'REMOVE FROM WISHLIST' : 'ADD TO WISHLIST'}
                            </button>
                            <button type="button" className='text-sm leading-7 font-medium text-gray-900 hover:text-indigo-600 transition-colors uppercase text-right' onClick={() => handleRemoveProduct(product)}> REMOVE</button>
                        </div>
                    </div>
                </li>
            ))}
            <ConfirmDialog message="Are you sure you want to remove this item?" isOpen={isModalOpen} onCancel={handleCancelRemove} onConfirm={handleOnConfirmAction} />
        </ul>

    );
}

export default CartItems;